import * as React from 'react'
import Page from '../../components/page/Page'
import {
  Checkbox,
  createStyles,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Theme,
  withStyles,
  WithStyles,
  withTheme,
  WithTheme
} from "@material-ui/core";
import {RouteComponentProps} from "@reach/router";
import MarginRow from "../../components/page/MarginRow";
import TitleBar from "../../components/TitleBar";
import {inject, observer} from "mobx-react";
import AccountStore from "../../stores/AccountStore";
import {observable, when} from "mobx";
import Progress from "../../components/Progress";
import FormValidator from "../../components/form/FormValidator";
import TextFieldValidator from "../../components/form/TextFieldValidator";
import DialogButton from "../../components/form/DialogButton";
import ControlTower, {Routes} from "../../components/ControlTower";
import {
  AccountStatus,
  AccountType,
  ActivityType,
  ClassStatus,
  CreateRegistrationInput,
  CreateUserInput,
  LessonStatus,
  ModelAccountFilterInput,
  UpdateUserInput,
  UserRole,
  UserStatus
} from "../../API";
import Notify from "../../components/notify/Notify";
import User from "../../model/User";
import Registration from "../../model/Registration";
import Class from "../../model/Class";
import UserStore from "../../stores/UserStore";
import Tracking from "../../components/Tracking";
import {getISODateTime} from "../../stores/StoreUtilities";
import Visible from "../../components/Visible";
import PasswordChangeDialog from "../../components/auth/PasswordChangeDialog";
import EmailChangeDialog from "../../components/auth/EmailChangeDialog";
import Confirm from "../../components/confirm/Confirm";
import Account from "../../model/Account";
import ProgressButton from "../../components/form/ProgressButton";
import {CopyToClipboard} from 'react-copy-to-clipboard';

const styles = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'flex-start',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),

  },
  titleBar: {
    flexGrow: 1,
    justifyContent: "space-between",
    width: "100%",
    height: 40,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  message: {
    color: theme.palette.error.main,
    marginTop: 10
  },
  dialogPaper: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    width: '100%',
    marginTop: theme.spacing(1)
  },
  form: {
    width: '100%'
  },
  dialogContent: {
    padding: theme.spacing(1),
    "&:first-child": {
      paddingTop: 4
    }
  },
  dialogActions: {
    justifyContent: "center",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  dialogActionsGrid: {
    justifyContent: "space-evenly",
    width: "100%",
  },
  dialogTitle: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textAlign: 'center'
  },
  label: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2),
  },
  checkboxLabel: {
    color: theme.palette.text.secondary,
    marginLeft: 0,
  },
  resendButton: {
    color: theme.palette.secondary.main,
    paddingLeft: 0,
    paddingRight: theme.spacing(2)
  },
  radioGroup: {
    margin: 0,
    padding: 0
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    fontWeight: 'bold',
    letterSpacing: 0.7,
    // borderRadius: 2,
    marginTop: 0,
    paddingTop: 7,
    paddingBottom: 5,
    marginLeft: "0px",
    textTransform: "uppercase",
    "&:hover": {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.light,
    }
  },
  accountSelector: {
    width: "50%"
  }
})

interface IUserEditPageProps {
  accountId?: string
  userId?: string
  accountStore?: AccountStore
  userStore?: UserStore
  progress?: Progress
  notify?: Notify
  confirm?: Confirm
  location?: any
}

@inject("accountStore", "userStore", "progress", "notify", "confirm")
@observer
class UserEditPage extends React.Component<WithStyles<typeof styles> & RouteComponentProps & IUserEditPageProps & WithTheme> {

  @observable isLoading = true
  @observable user?: User
  @observable values = {
    firstName: "",
    lastName: "",
    jobTitle: "",
    email: "",
    phone: "",
    userRole: "Student",
    sendInvite: false,
    userStatus: "Invited"
  }
  @observable accounts: Account[] = []
  @observable account?: Account
  @observable registrations: Registration[] = []
  @observable message = ""
  @observable showPasswordChange = false
  @observable showEmailChange = false
  @observable isSubmitting = false
  private classId?: any

  componentDidMount () {
    const { accountId, userId, userStore, accountStore, progress} = this.props
    this.isLoading = true
    when(
      () => !userStore!.isLoading && accountId !== undefined,
      async () => {
        // Get classId query param
        this.classId = new URLSearchParams(this.props.location.search).get("classId")
        console.log(`classId = ${this.classId}`)
        await accountStore!.loadAccount(accountId!)

        if (userId) {
          progress!.show("UserEditPage")
          this.user = await accountStore!.loadUser(userId!)
          if (this.user) {
            this.values = {
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              jobTitle: this.user.jobTitle,
              email: this.user.email,
              phone: this.user.phone,
              userRole: this.user.isOwner ? "Owner" : (this.user.isAdmin ? "Admin" : "Student"),
              userStatus: this.user.userStatus.toString(),
              sendInvite: false
            }
            this.account = this.user.account
            await this.loadAccounts()
            this.loadRegistrations()
          }
          this.isLoading = false
          progress!.hide("UserEditPage")
        } else {
          this.loadRegistrations()
          this.isLoading = false
          progress!.hide("UserEditPage")
        }
      }
    )

  }


  render() {
    const { classes, userStore, userId, accountStore, notify } = this.props

    const title = this.user ? "Edit Person" : "Add Person"
    const isAdmin = userStore!.isAdmin
    const isOwner = isAdmin || userStore!.isOwner
    const isIndividual = accountStore!.isIndividual
    const roleDisabled = false // (userId !== undefined) // Not needed

    return (
      <Page title={title}>
        <MarginRow>
          <Grid container className={classes.root} direction="column">
            <TitleBar title={title} className={classes.titleBar}>
            </TitleBar>
            <Paper className={classes.dialogPaper}>
              <FormValidator autoComplete="off"
                             name="UserEditForm" id="UserEditForm" className={classes.form}>
                <DialogContent className={classes.dialogContent}>
                  <TextFieldValidator
                    autoFocus
                    margin="dense"
                    name="firstName"
                    label="First Name"
                    type="text"
                    variant="standard"
                    validators={{required:true}}
                    onChange={this.onChange}
                    value={this.values.firstName}
                    fullWidth
                  />
                  <TextFieldValidator
                    margin="dense"
                    name="lastName"
                    label="Last Name"
                    type="text"
                    variant="standard"
                    validators={{required:true}}
                    onChange={this.onChange}
                    value={this.values.lastName}
                    fullWidth
                  />
                  <TextFieldValidator
                    margin="dense"
                    name="jobTitle"
                    label="Job Title"
                    type="text"
                    variant="standard"
                    validators={{}}
                    onChange={this.onChange}
                    value={this.values.jobTitle}
                    fullWidth
                  />
                  <TextFieldValidator
                    margin="dense"
                    name="email"
                    id="EmailInput"
                    label="Email"
                    variant="standard"
                    placeholder=""
                    type="text"
                    validators={{required:true, isEmail: true}}
                    value={this.values.email}
                    onChange={this.onChange}
                    fullWidth
                    autoCorrect="off"
                    autoCapitalize="off"
                    autoComplete="on"
                    disabled={this.user !== undefined}
                  />
                  { this.user && this.user.userStatus !== UserStatus.Registered && this.user.userStatus !== UserStatus.Suspended &&
                    [<DialogButton variant="tertiary" onClick={this.onResendInvite} customClassName={classes.resendButton}>
                       SEND INVITATION
                     </DialogButton>,
                      <CopyToClipboard
                        text={this.registerUrl}
                        onCopy={() => notify!.show('success', 'Copied invitation link to clipboard!')}>
                        <DialogButton variant="tertiary" customClassName={classes.resendButton}>
                          COPY INVITATION
                        </DialogButton>
                      </CopyToClipboard>
                    ]
                  }
                  { this.user && this.user.id === userStore!.user!.id &&
                    <DialogButton variant="tertiary" onClick={this.onChangeEmailOpen} customClassName={classes.resendButton}>
                      CHANGE EMAIL &nbsp;&nbsp;&nbsp;&nbsp;
                    </DialogButton>
                  }
                  { this.user && this.user.id === userStore!.user!.id &&
                    <DialogButton variant="tertiary" onClick={this.onChangePasswordOpen} customClassName={classes.resendButton}>
                      CHANGE PASSWORD
                    </DialogButton>
                  }
                  <TextFieldValidator
                    margin="dense"
                    name="phone"
                    label="Phone Number"
                    type="text"
                    variant="standard"
                    validators={{isMobilePhone:null, required:false}}
                    onChange={this.onChange}
                    value={this.values.phone}
                    fullWidth
                  />
                  {/*<div>*/}
                  {/*  <FormControlLabel*/}
                  {/*    value=""*/}
                  {/*    label="Send Email Invitation"*/}
                  {/*    labelPlacement="end"*/}
                  {/*    className={classes.checkboxLabel}*/}
                  {/*    control={*/}
                  {/*      <Checkbox name="sendInvite" color="secondary" checked={this.values.sendInvite} onChange={this.onChange}/>*/}
                  {/*    }*/}
                  {/*  />*/}
                  {/*</div>*/}
                  <Visible if={isAdmin || (isOwner && !isIndividual)}>
                    <div className={classes.label}>Role</div>
                    <RadioGroup aria-label="userRole" name="userRole" value={this.values.userRole} onChange={this.onChange} row>
                      <FormControlLabel
                        value="Student"
                        control={<Radio color="secondary" disabled={roleDisabled}/>}
                        label="Student"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Owner"
                        control={<Radio color="secondary"  disabled={roleDisabled}/>}
                        label="Owner"
                        labelPlacement="end"
                      />
                      {isAdmin &&
                        <FormControlLabel
                          value="Admin"
                          control={<Radio color="secondary"  disabled={roleDisabled}/>}
                          label="Admin"
                          labelPlacement="end"
                        />
                      }
                    </RadioGroup>
                    <Visible if={isOwner}>
                      <div className={classes.label}>Status</div>
                      <RadioGroup aria-label="userStatus" name="userStatus" className={classes.radioGroup}
                                  value={this.values.userStatus} onChange={this.onChange} row>
                        <FormControlLabel
                          value="Inactive"
                          control={<Radio color="secondary"/>}
                          label="Inactive"
                          labelPlacement="end"
                          disabled={userId !== undefined}
                        />
                        <FormControlLabel
                          value="Invited"
                          control={<Radio color="secondary"/>}
                          label="Invited"
                          labelPlacement="end"
                          disabled={userId !== undefined}
                        />
                        <FormControlLabel
                          value="Registered"
                          control={<Radio color="secondary"/>}
                          label="Registered"
                          labelPlacement="end"
                          disabled={this.values.userStatus === "Inactive" || this.values.userStatus === "Invited"}
                        />
                        <FormControlLabel
                          value="Suspended"
                          control={<Radio color="secondary"/>}
                          label="Suspended"
                          labelPlacement="end"
                          disabled={this.values.userStatus === "Inactive" || this.values.userStatus === "Invited"}
                        />
                        <Visible if={this.user !== undefined && this.user!.userStatus === UserStatus.Deleted}>
                          <FormControlLabel
                            value="Deleted"
                            control={<Radio color="secondary"/>}
                            label="Deleted"
                            labelPlacement="end"
                            disabled={true}
                          />
                        </Visible>
                      </RadioGroup>
                    </Visible>
                    <Visible if={this.user !== undefined && isAdmin && this.user.id !== userStore!.user!.id}>
                      <TextFieldValidator
                        type="text"
                        className={classes.accountSelector}
                        variant="standard"
                        name="account"
                        label="Change Account"
                        autocompleteOptions={{
                          options: this.accounts,
                          getOptionLabel: (option: Account) => option?.name,
                          getOptionSelected: (option: Account, value: Account) => option.id === value.id,
                          value: this.account,
                          onChange: this.onSelectAccount,
                          disableClearable: false
                        }}
                      />
                    </Visible>
                    <Visible if={this.values.userRole !== "Admin" && userId === undefined}>
                      <div className={classes.label}>Classes</div>
                      <FormGroup row>
                        {this.registrations.map((r: Registration) => {
                          return <FormControlLabel
                            value={r.classId}
                            control={
                              <Checkbox color="secondary" name="registration" id={r.classId}
                                        checked={r.id !== ""}
                                        disabled={r.createdAt !== undefined}
                                        onChange={this.onChange}/>}
                            label={r.class?.course?.title}
                            labelPlacement="end"
                            key={r.classId}
                          />
                        })
                        }
                      </FormGroup>
                    </Visible>
                  </Visible>

                  <DialogContentText className={classes.message}>
                    {this.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                  <Grid container direction="row" className={classes.dialogActionsGrid}>
                    <Grid item xs={2}>
                      <Visible if={isAdmin && this.account !== undefined && this.user !== undefined &&
                        this.user!.userStatus !== UserStatus.Deleted && this.user.id !== userStore!.user!.id}>
                        <DialogButton variant="primary" onClick={this.onDelete} customClassName={classes.deleteButton}>
                          DELETE...
                        </DialogButton>
                      </Visible>
                    </Grid>
                    <Grid item xs={8} style={{display:"flex", justifyContent:"center"}}>
                      <DialogButton variant="secondary" onClick={this.onCancel}>
                        CANCEL
                      </DialogButton>
                      <div style={{flexGrow:0, width:10}}/>
                      <ProgressButton variant="contained" color="secondary"
                                      processing={this.isSubmitting}
                                      onClick={this.onSubmit}>
                        SAVE
                      </ProgressButton>
                    </Grid>
                    <Grid item xs={2}>

                    </Grid>
                  </Grid>
                </DialogActions>
              </FormValidator>
            </Paper>
          </Grid>

          {this.showEmailChange &&
            <EmailChangeDialog oldEmail={this.values.email} onClose={this.onEmailChangeClose} onChange={this.onEmailChange}/>
          }
          {this.showPasswordChange &&
            <PasswordChangeDialog onClose={this.onPasswordChangeClose}/>
          }
        </MarginRow>
      </Page>
    )
  }

  async loadAccounts() {
    const { accountStore, userStore } = this.props
    if (userStore!.user?.isAdmin) {
      // Filter only active accounts
      const filter: ModelAccountFilterInput = {
        accountStatus: {eq: AccountStatus.Active}
      }
      const accounts: Account[] = await accountStore!.listAccounts(filter)
      const sorted = accounts.sort((a: Account, b: Account) => a.name.localeCompare(b.name))
      this.accounts = sorted
    } else {
      this.accounts = []
    }
  }

  loadRegistrations = async () => {
    const { accountStore } = this.props

    const classes = await accountStore!.listClasses()

    let registrations: Registration[] = []

    if (this.user) {
      registrations = [...this.user!.registrations]

      registrations.forEach((r: Registration) => {
        const classFound = classes.find((c: Class) => c.id === r.classId)
        if (classFound) {
          r.class = classFound
        }
      })
    }

    // Add pseudo-registrations for unregistered classes
    classes.forEach((c: Class) => {
      // Check for existing registration
      if (!c.userId) {
        if (!registrations.find((r: Registration) => { return r.classId === c.id})) {

          const reg = new Registration({
            id: (this.classId && this.classId === c.id) ? "checked" : "",
            accountId: c.accountId,
            classId: c.id,
            class: c,
            userId: null,
            user: undefined,
            classStatus: ClassStatus.NotStarted,
            classProgress: 0,
            lessonNumber: 1,
            lessonStatus: LessonStatus.NotStarted,
            videoProgress: 0,
            score: 0
          })
          registrations.push(reg)
        }
      }
    })

    // Sort by course title
    registrations.sort((a: Registration, b: Registration) => {
      return a.title.localeCompare(b.title)
    })

    this.registrations = registrations
  }

  get registerUrl() {
    if (this.user && this.user.id) {
      const url = new URL(window.location.href)
      return `${url.origin}/register/${this.user!.id}`
    } else {
      return ""
    }
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name
    if (name === "sendInvite") {
      this.values![name] = event.target.checked
    } else if (name === "registration") {
      this.toggleRegistration(event.target.id)
    } else {
      this.values[name] = event.target.value
    }
  }

  onSelectAccount = async (event: any, value: any, reason: any) => {
    this.account = value as Account
  }

  toggleRegistration = (id: string) => {
    const found = this.registrations.find((r: Registration) => { return r.classId === id})
    if (found) {
      if (found.id === "checked") {
        found.id = ""
      } else if (found.id === "") {
        found.id = "checked"
      }
      this.registrations = [...this.registrations]
    }
  }

  onResendInvite = async () => {
    const { accountStore, notify } = this.props
    if (!this.user || this.user.userStatus === UserStatus.Registered) {
      return
    }

    // Set to Inactive, then Invited to cause resend
    const update: UpdateUserInput = {
      id: this.user!.id,
      userStatus: UserStatus.Inactive,
    }

    let user = await accountStore!.updateUser(update)
      .catch((err: Error) => {
        notify!.show("error", err.message)
      })

    if (user) {
      update.userStatus = UserStatus.Invited
      update.invitedAt = getISODateTime()
      user = await accountStore!.updateUser(update)
        .catch((err: Error) => {
          notify!.show("error", err.message)
        })

      if (user) {
        this.user = user
        this.values.userStatus = UserStatus.Invited.toString()
        notify!.show("success", "Email invitation sent!")
      }
    }
  }

  onChangeEmailOpen = () => {
    this.showEmailChange = true
  }

  onEmailChange = (newEmail: string) => {
    this.values.email = newEmail
    this.showEmailChange = false
    this.updateEmail()
  }

  onEmailChangeClose = () => {
    this.showEmailChange = false
  }

  onChangePasswordOpen = () => {
    this.showPasswordChange = true
  }

  onPasswordChangeClose = () => {
    this.showPasswordChange = false
  }

  onDelete = async () => {
    const { accountStore, confirm, notify } = this.props

    if (this.user) {
      confirm!.show("Confirm Delete",
        `Please confirm you want to delete ${this.user!.fullName}`,
        ["Confirm", "Cancel"],
        async () => {
          const user = await accountStore!.deleteUser(this.user!)
            .catch((err: Error) => {
              notify!.show("error", "Error deleting person")
            })
          if (user) {
            this.onCancel()
            return true
          } else {
            return false
          }
        },
        () => {
          // Do nothing
        })
    }
  }

  onCancel = () => {
    const { userStore, accountStore } = this.props
    const accountId = accountStore!.account!.id

    let route
    if (this.props.location) {
      route = new URLSearchParams(this.props.location.search).get('ret')
    }
    if (!route) {
      if (this.classId) {
        route = `${Routes.account}/${accountId}/class/${this.classId}`
      } else if (userStore!.isOwner || userStore!.isAdmin) {
        route =`${Routes.account}/${accountId}/people`
      } else {
        route =`${Routes.account}/${accountId}/info`
      }
    }

    ControlTower.route(route)
  }

  onSubmit = async () => {
    const { userId, accountStore, userStore, notify, confirm } = this.props

    this.isSubmitting = true

    const values = this.values

    if (userId) {
      Tracking.event({action: 'UpdateUser'})
      const input: UpdateUserInput = {
        id: userId!,
        firstName: values.firstName,
        lastName: values.lastName,
        jobTitle: values.jobTitle,
        email: values.email.toLowerCase(),
        phone: values.phone,
        role: UserRole.Student,
        userStatus: UserStatus[values.userStatus]
      }
      switch (values.userRole) {
        case "Owner":
          input.role = UserRole.Owner
          break
        case "Admin":
          input.role = UserRole.Admin
          break
      }

      let user = undefined
      if (userId === userStore!.user!.id) {
        user = await userStore!.updateUser(input)
          .catch((err: Error) => {
            notify!.show("error", "Unable to update user")
          })
      } else {
        let isMigrated = false

        if (this.account && this.account.id !== this.user!.accountId) {
          input.accountId = this.account.id
          if (this.user && this.user.account) {
            if (this.user.account!.accountType === AccountType.Individual &&
              this.account.accountType === AccountType.Agency &&
              this.user.role === UserRole.Owner) {
              // Switch role to student if moving from an individual account to an agency account
              input.role = UserRole.Student
              input.customerId = this.user.account!.customerId
            } else if (this.user.account.accountType === AccountType.Agency &&
              this.account.accountType === AccountType.Individual &&
              this.user.role === UserRole.Student) {
              // Switch role to owner if moving from an agency account to and individual account
              input.role = UserRole.Owner
            }
          }

          isMigrated = await accountStore!.migrateUserToAccount(this.user!, this.account)
        }
        user = await accountStore!.updateUser(input)
          .catch((err: Error) => {
            notify!.show("error", "Unable to update user")
          })

        if (user && isMigrated && this.user!.account!.accountType === AccountType.Individual) {
          confirm!.show("Confirm Delete",
            `Do you also want to delete this individual account (${this.user!.account!.name})?`,
            ["Yes", "No"],
            async () => {
              const account = await accountStore!.deleteAccount(this.user!.account!)
                .catch((err: Error) => {
                  notify!.show("error", err.message)
                })

              if (account) {
                const option = (account.accountStatus === AccountStatus.Deleted) ? "soft " : ""
                notify!.show("success", `Account has been ${option}deleted.`)
                ControlTower.route(Routes.accounts)
              }
              return true
            },
            () => {
              // Do nothing
            })
        }
      }

      if (user) {
        // Add registrations
        await this.registerUserForClasses(user)

        notify!.show("success", "User updated!")
        this.isSubmitting = false
        this.onCancel()
      } else {
        this.isSubmitting = false
      }
    } else {
      // New user
      Tracking.event({action: 'CreateUser'})
      const input: CreateUserInput = {
        accountId: accountStore!.account!.id,
        firstName: values.firstName,
        lastName: values.lastName,
        jobTitle: values.jobTitle,
        email: values.email.toLowerCase(),
        phone: values.phone,
        userStatus: (values.userRole === "Owner" || values.userRole === "Admin") ? UserStatus.Invited : UserStatus.Inactive,
        role: UserRole[values.userRole]
      }

      const user = await accountStore!.createUser(input)
        .catch((err: Error) => {
          notify!.show("error", err.message)
        })

      if (user) {
        notify!.show("success", "User added!")
        userStore!.createActivity(ActivityType.UserCreate, user.id)
        // Add registrations
        await this.registerUserForClasses(user)
        this.isSubmitting = false
        this.onCancel()
      } else {
        this.isSubmitting = false
      }
    }

  }

  registerUserForClasses = async (user: User) => {
    this.registrations.forEach(async (r: Registration) => {
      if (r.id === "checked") {
        await this.registerUserForClass(user, r.classId)
      }
    })
  }

  registerUserForClass = async (user: User, classId: string) => {
    const { accountStore, userStore, notify} = this.props

    const classObj = await accountStore!.getClass(classId)
    if (!classObj) {
      console.log(`Class not found: ${classId}`)
      return
    }

    // Register for class
    const input: CreateRegistrationInput = {
      accountId: user.accountId,
      classId: classId,
      userId: user.id,
      classStatus: ClassStatus.NotStarted,
      classProgress: 0,
      lessonNumber: 1,
      lessonStatus: LessonStatus.NotStarted,
      videoProgress: 0,
      score: 0,
      lessonsAssigned: classObj.getRegistrationLessonsAssigned()
    }

    const registration = await accountStore!.addClassRegistration(input)
      .catch(err => {
        notify!.show("warning", err.message)
      })

    if (registration) {
      userStore!.createActivity(ActivityType.ClassRegistration, registration.classId)
    }
    return registration
  }

  private updateEmail = async () => {
    const { userId, userStore, notify } = this.props

    const input: UpdateUserInput = {
      id: userId!,
      email: this.values.email.toLowerCase(),
    }

    await userStore!.updateUser(input)
        .catch((err: Error) => {
          notify!.show("error", "Unable to update user email")
        })
  }
}

export default withTheme((withStyles(styles)(UserEditPage)))